import { Stack } from '@mui/material'
import { useAuthContext } from 'components/context/AuthProvider'
import FailPlaceholder from 'components/placeholders/FailPlaceholder'
import LoadingPlaceholder from 'components/placeholders/LoadingPlaceholder'
import { useTeams } from 'features/Timeline/hooks/useTeams'
import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { getSharedTimelineById, selectSharedTimelineSlice } from 'store/slice/sharedTimeline.slice'
import { SharedTimelineList } from '../SharedTimelineList/SharedTimelineList'

export function SharedTimelineTab() {
  const dispatch = useAppDispatch()
  const { user } = useAuthContext()
  const userId = user?.id
  const { isLoading, timeline } = useAppSelector(selectSharedTimelineSlice)
  const { activeTeamId } = useTeams()

  useEffect(() => {
    if (activeTeamId === null || !userId) return
    dispatch(getSharedTimelineById({ userId, teamId: activeTeamId }))
  }, [dispatch, userId, activeTeamId])

  if (isLoading) {
    return <LoadingPlaceholder />
  }

  if (!timeline || timeline.length === 0) {
    return <FailPlaceholder error="No data has been shared by the team" />
  }

  return (
    <Stack paddingLeft={{ xs: 2, sm: 2 }} paddingRight={{ xs: 2, md: 0 }} spacing={2} mt={2}>
      <SharedTimelineList timeline={timeline} />
    </Stack>
  )
}
